import { DEFAULT_INITIAL_PAGINATION_DATA } from "@saleor/config";
import { configurationOpsMenuUrl } from "@saleor/configuration_operations";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import {
  createPaginationState,
  PaginationState
} from "@saleor/hooks/usePaginator";
import { maybe } from "@saleor/misc";
import { RemittanceRunnerListUrlQueryParams } from "@saleor/remittanceRunner/url";
import usePaginatorRemittance from "@saleor/remittanceRunner/utils/paginators";
import { ListViews } from "@saleor/types";
import * as React from "react";

import RiderRemittanceConfigPage from "../components/RiderRemittanceConfigPage/RiderRemittanceConfigPage";
import { useRemittanceMallsConfig } from "../queries";
import { riderReminderUrl } from "../urls";

interface RemittanceRunnerListProps {
  params: RemittanceRunnerListUrlQueryParams;
}

const RiderReminderList: React.FC<RemittanceRunnerListProps> = ({ params }) => {
  const paginateRemittance = usePaginatorRemittance();
  const navigate = useNavigator();

  const { updateListSettings, settings } = useListSettings(ListViews.MALL_LIST);

  const [
    queryVariablesRemittance,
    setQueryVariablesRemittance
  ] = React.useState<PaginationState>({ first: settings.rowNumber });

  const { data, refetch } = useRemittanceMallsConfig({
    displayLoader: true,
    variables: {
      ...queryVariablesRemittance,
      status: "ACT"
    }
  });

  const mallList = maybe(() => data.malls.edges.map(edges => edges.node));

  const paginationStateRemittanceReminder =
    createPaginationState(settings.rowNumber, params)?.first !== null
      ? createPaginationState(settings.rowNumber, params)
      : { first: settings.rowNumber };

  const {
    loadNextPageRemittance,
    loadPreviousPageRemittance,
    pageInfoRemittance
  } = paginateRemittance(
    data?.malls?.pageInfo,
    paginationStateRemittanceReminder,
    params
  );

  React.useEffect(() => {
    navigate(
      riderReminderUrl({
        ...params,
        ...DEFAULT_INITIAL_PAGINATION_DATA
      }),
      true
    );
  }, [settings.rowNumber]);

  React.useMemo(() => {
    setQueryVariablesRemittance(paginationStateRemittanceReminder);
  }, [params]);

  return (
    <RiderRemittanceConfigPage
      refetch={refetch}
      data={data}
      mallList={mallList}
      settings={settings}
      onUpdateListSettings={updateListSettings}
      pageInfo={pageInfoRemittance}
      onPreviousPage={loadPreviousPageRemittance}
      brands={undefined}
      onAdd={null}
      disabled={false}
      onRowClick={null}
      onNextPage={loadNextPageRemittance}
      onBack={() => navigate(configurationOpsMenuUrl)}
    />
  );
};

export default RiderReminderList;
